import { environment } from '../../../environments/environment';
import { LoginExternoResult, UsuarioInfo } from '../../features/autenticacao/login/login.model';
import { UsuarioVinculoModel } from '../../features/vincular-conta/vincular-conta.model';
import { CriptografiaUtil } from './criptografia.extensions';

export class RouterExtensions {
  static processaTituloPagina(titulo: string): string {
    return `${titulo} | ${environment.aplicacao.nome}`;
  }

  /**
   * Monta os queryParams necessários para redirecionar o usuário logado ao fluxo de
   * confirmação de vínculo de instituição, usado tanto pelo login quanto pela validação de MFA.
   */
  static montaQueryParamsVincularInstituicao(userInfo: UsuarioInfo) {
    const scope_usr: UsuarioVinculoModel = {
      id: userInfo.id,
      nome: userInfo.nomeCompleto,
      email: userInfo.email,
    };

    return { scope_usr: CriptografiaUtil.crypt64(scope_usr) };
  }

  static processaReturnUrlLoginExterno(
    urlExterna: string,
    loginExternoInfo: LoginExternoResult,
    delegateLogin?: string | null
  ) {
    let url =
      (urlExterna.indexOf('?') >= 0 ? `${urlExterna}&` : `${urlExterna}?`) +
      `token=${encodeURIComponent(
        loginExternoInfo.token
      )}&usuarioId=${loginExternoInfo.usuarioId}`;

    if (delegateLogin) {
      url += `&delegateLogin=${encodeURIComponent(delegateLogin)}`;
    }

    return url;
  }
}
